import React from 'react';
import './styles/VideoEditor.css';

function Progress({ progress, className }) {
    return (
        <div className={`progress-bar ${className || ''}`}>
            <div className="progress-bar-fill" style={{ width: `${progress}%` }}>
                <span className="progress-bar-text">{progress}%</span>
            </div>
        </div>
    );
}

export default Progress;
